<script>
import vSelect from "vue-select"
import "vue-select/dist/vue-select.css"


export default {
  name: "AuthorPicker",
  components: {
    vSelect,
  },
  props: {
    value:        { type: Object, required: true  },
    required:     { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      debug: false,
      key: 0,
      options: [],
      selected: {text: "", value: ""},
      observer: null,
      limit: 10,
      search: "",
    }
  },
  computed: {
    filtered () {
      return this.options.filter(itm => itm.text ? itm.text.toLowerCase().includes(this.search.toLowerCase()) : false)
    },
    paginated () {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage () {
      return this.paginated.length < this.filtered.length
    },
    readOnly () {
      return this.value.readOnly !== null ? this.value.readOnly : false
    },
    clearable () {
      return Object.keys(this.value).indexOf("clearable") > -1 ? this.value.clearable : false
    },
  },
  watch: {
    value: {
      handler(data) {
        if (this.debug) console.log("AuthorPicker Data:", data)
        this.$emit("input", data)
        if (!data) {
          this.retrievePeople()
        } else {
          this.updateSelected(data)
        }
      },
      deep: true,
    },
    selected(sel) {
      this.value.value = sel !== null ? sel : ""
    },
  },
  created() {
    this.retrievePeople()
    this.observer = new IntersectionObserver(this.infiniteScroll)
  },
  methods: {
    updateSelected(newVal) {
      if (newVal === null) newVal = ""
      for (let i=0;i<this.options.length;i++) {
        const cur = this.options[i]
        if (cur.value == newVal.value) {
          this.selected = {
            text: cur.text,
            value: cur.value,
          }
          break
        }
      }
    },
    retrievePeople() {
      this.$store.dispatch("publication/getActiveAuthors").then((data) => {
        const authorList = [{ value: "", text: this.value.defaultLabel }]
        this.selected = authorList[0]
        for (let i=0;i<data.length;i++) {
          authorList.push({
            value: data[i].authorId,
            text: `${data[i].nameLast}, ${data[i].nameFirst}`,
          //selected: data[i].authorId == this.value.value
          })
          if (data[i].authorId == this.value.value) {
            this.selected = {
              value: data[i].authorId,
              text: `${data[i].nameLast}, ${data[i].nameFirst}`,
            }
          }
        }
        //if (this.allowOther) { siteList.push({ value: 'other',   text: 'Other' }) }
        this.options = authorList
        this.key++
      })
    },
    onChange(data) {
      this.$emit("change", data)
    },
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      console.log(this.selected)
      if (this.selected.text === "Create New") {
        this.$emit("openCreateNewModal")
      } else {
        this.$emit("sendSelectedToTable", this.selected)
      }
      this.observer.disconnect()
    },
    async infiniteScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
  },
}
</script>

<template>
  <v-select
    v-model="selected"
    :id="value.id"
    :key="key"
    label="text"
    :options="paginated"
    :filterable="false"
    :disabled="readOnly"
    @change="onChange"
    @open="onOpen"
    @close="onClose"
    @search="query => search = query"
  >
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">
        Loading more options...
      </li>
    </template>
  </v-select>
</template>
